import { useState, useCallback } from 'react';
import { CaptchaState } from '../types/ContactForm';

export const useCaptcha = () => {
  const [captcha, setCaptcha] = useState<CaptchaState>({ 
    num1: 0, 
    num2: 0, 
    result: '' 
  });

  const generateCaptcha = useCallback(() => {
    const num1 = Math.floor(Math.random() * 10) + 1;
    const num2 = Math.floor(Math.random() * 10) + 1;
    setCaptcha({ num1, num2, result: '' });
  }, []);

  const updateCaptchaResult = useCallback((result: string) => {
    setCaptcha(prev => ({ ...prev, result }));
  }, []);

  return {
    captcha,
    generateCaptcha,
    updateCaptchaResult
  };
}; 